import React from 'react';
import Chat from "../../components/chat/Chat";
import EmptyBanner from '../../components/EmptyBanner';

const MessagesTab = ({ candidate, position, opportunity, project, onFetchSuccess, hasPermission = true, hasRequestedSOW = false }) => {
    if (!opportunity && candidate && hasRequestedSOW && !candidate.isAssigned()) {
        return (
            <div className="h-full p-4 bg-white text-center">
                <EmptyBanner
                    message="Messages are disabled once SOW is in progress."
                    icon="fa fa-comments"
                />
            </div>
        )
    }

    if (!opportunity && candidate && !candidate.isShortlisted()) {
        return (
            <div className="h-full p-4 bg-white text-center">
                <EmptyBanner
                    message="Candidate must be invited to shortlist and show interest for this position before messaging can be requested."
                    icon="fa fa-comments"
                />
            </div>
        )
    }

    if (opportunity && (!opportunity.id || opportunity.isInterested())) {
        return (
            <div className="h-full p-4 bg-white text-center">
                <EmptyBanner
                    message="Messages are only available once the candidate has been invited."
                    icon="fa fa-comments"
                />
            </div>
        )
    }

    if (!hasPermission) {
        return (
            <div className="h-full p-4 bg-white text-center">
                <EmptyBanner
                    message={(
                        <div className="text-center">
                            <p>
                                You don't have the appropriate group permissions to message candidates
                            </p>
                        </div>
                    )}
                    icon="fa fa-lock"
                />
            </div>
        )
    }

    return (
        <React.Fragment>
            <Chat
                positionId={position?.id}
                candidate={candidate}
                projectId={project?.id}
                onFetchSuccess={onFetchSuccess}
            />
        </React.Fragment>
    );
};

export default MessagesTab;